import { supabase } from '@/lib/supabase';
import type { SiteSettings } from '@/types/db';

export async function getSettings(): Promise<SiteSettings | null> {
  const { data, error } = await supabase.from('site_settings').select('*').eq('id', 1).maybeSingle();
  if (error) throw error;
  return data;
}

export async function updateSettings(patch: Partial<SiteSettings>): Promise<SiteSettings> {
  const { data, error } = await supabase
    .from('site_settings')
    .update(patch)
    .eq('id', 1)
    .select()
    .single();
  if (error) throw error;
  return data;
}
